import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetchReelsStatisticList } from "../actions/reels";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import { toast } from "react-toastify";
import { createDateColumn } from "../utils/agGridDateColumn";

const ReelsStatistic = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { reelsStatisticList } = useSelector((state) => state.reelsReducer);

  //breadcrumb
  const translateModule = "reels";
  const pageType = "StatisticList";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchReelsStatisticList());
  }, [dispatch]);

  const columnDefs = [
    {
      headerName: "Naziv",
      field: "reelName",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
    {
      headerName: "Putanja reel-a",
      field: "link",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Broj klikova po danu",
      field: "click",
      filter: "agTextColumnFilter",
      maxWidth: 300,
    },
    createDateColumn("Na dan", "date"),
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        reloadData={() =>
          dispatch(fetchReelsStatisticList()).then(() => {
            toast.success("Podaci su uspešno osveženi", {
              theme: "colored",
            });
          })
        }
        rowData={reelsStatisticList}
        columnDefs={columnDefs}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey="reel-statistic-list"
      />
    </Fragment>
  );
};

export default ReelsStatistic;
